// import React from "react";
// import PropTypes from "prop-types";
// import images from "../../../images";
// import { cn } from "../../../Utils/helper";

// const Search = ({
//   searchQuery = "",
//   onSearchChange,
//   onFavoriteToggle,
//   showFavorites = false,
//   isFavorited = false,
//   placeholder,
//   className = "",
//   ...props
// }) => {
//   const handleInputChange = (e) => {
//     if (onSearchChange) {
//       onSearchChange(e.target.value);
//     }
//   };

//   // const handleClearSearch = () => {
//   //   if (onSearchChange) {
//   //     onSearchChange("");
//   //   }
//   // };

//   const handleFavoriteClick = (e) => {
//     e.stopPropagation();
//     if (onFavoriteToggle) {
//       onFavoriteToggle();
//     }
//   };

//   return (
//     <div className={cn(`relative w-full ${className}`)} {...props}>
//       <div className="flex items-center bg-white rounded-lg p-[10px] border border-[#A0A0A0] transition-all duration-200">
//         <div className="flex-shrink-0  mr-1.5">
//           <img
//             src={images.SearchIcon || "/icons/search.svg"}
//             alt="search"
//             className="w-[24px] h-[24px] text-[#A0A0A0]"
//           />
//         </div>

//         <input
//           type="text"
//           value={searchQuery}
//           onChange={handleInputChange}
//           placeholder={placeholder || ""}
//           className="flex-1 outline-none bg-transparent text-[#333333] placeholder:text-[#A0A0A0] placeholder:text-base text-base font-medium"
//         />
//         {showFavorites && (
//           <button
//             onClick={handleFavoriteClick}
//             className="flex-shrink-0 ml-3 p-1 hover:scale-110 transition-transform duration-200"
//           >
//             <img
//               src={
//                 isFavorited ? images.Heart02ActiveIcon : images.HeartGrayIcon
//               }
//               alt="favorite"
//               className="w-[24px] h-[24px]"
//             />
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// Search.propTypes = {
//   searchQuery: PropTypes.string,
//   onSearchChange: PropTypes.func,
//   onFavoriteToggle: PropTypes.func,
//   showFavorites: PropTypes.bool,
//   isFavorited: PropTypes.bool,
//   placeholder: PropTypes.string,
//   className: PropTypes.string,
// };

// export default Search;
import React from "react";
import PropTypes from "prop-types";
import images from "../../../images";
import { cn } from "../../../Utils/helper";

const Search = ({
  searchQuery = "",
  onSearchChange,
  onFavoriteToggle,
  showFavorites = false, // Giữ lại showFavorites để kiểm soát việc hiển thị nút trái tim
  isFavorited = false, // isFavorited cho nút trái tim trên thanh search (nếu có trạng thái tổng thể)
  placeholder,
  className = "",
  ...props
}) => {
  const handleInputChange = (e) => {
    if (onSearchChange) {
      onSearchChange(e.target.value);
    }
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (onFavoriteToggle) {
      onFavoriteToggle(); // Gọi hàm toggle từ Home component
    }
  };

  return (
    <div className={cn(`relative w-full ${className}`)} {...props}>
      <div className="flex items-center bg-white rounded-lg p-[10px] border border-[#A0A0A0] transition-all duration-200">
        <div className="flex-shrink-0  mr-1.5">
          <img
            src={images.SearchIcon || "/icons/search.svg"}
            alt="search"
            className="w-[24px] h-[24px] text-[#A0A0A0]"
          />
        </div>

        <input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder={placeholder || ""}
          className="flex-1 outline-none bg-transparent text-[#333333] placeholder:text-[#A0A0A0] placeholder:text-base text-base font-medium"
        />
        {/* Nút trái tim trên thanh search */}
        {showFavorites && (
          <button
            onClick={handleFavoriteClick}
            className="flex-shrink-0 ml-3 p-1 hover:scale-110 transition-transform duration-200"
          >
            <img
              src={
                isFavorited ? images.Heart02ActiveIcon : images.HeartGrayIcon
              }
              alt="favorite"
              className="w-[24px] h-[24px]"
            />
          </button>
        )}
      </div>
    </div>
  );
};

Search.propTypes = {
  searchQuery: PropTypes.string,
  onSearchChange: PropTypes.func,
  onFavoriteToggle: PropTypes.func,
  showFavorites: PropTypes.bool, // Giữ lại prop này nếu bạn muốn kiểm soát việc hiển thị nút trái tim bên ngoài
  isFavorited: PropTypes.bool, // Trạng thái của nút trái tim trên thanh search
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default Search;
